import { styled } from '@mui/system';

export const ContentBox = styled('div')(() => ({
	display: 'flex',
	justifyContent: 'space-between',
	gap: '8px',
	marginTop: '8px',
	overflow: 'hidden',
	flexDirection: 'column',
}));

export const MarginDiv = styled('div')({
	display: 'flex',
	gap: '16px',
	overflow: 'hidden',
	marginBottom: '24px',
});

export const SubWrap = styled('div')(() => ({
	display: 'flex',
	gap: '8px',
	overflow: 'hidden',
	marginLeft: '133px',
}));
